import { TeamRole } from '@/consts/team'
import { useTeamUserRole } from '@/stores/team'

import { AdminHomeView } from './AdminHomeView'
import { MemberHomeView } from './MemberHomeView'

export function TeamHomePage() {
  const userRole = useTeamUserRole()

  // Determine which view to show based on user role
  const isAdmin = userRole && [TeamRole.Owner, TeamRole.Admin].includes(userRole)

  return isAdmin ? <AdminHomeView /> : <MemberHomeView />
}
